<template>
  <div class="page-mentor">
    <div class="g-wrap">
      <el-breadcrumb class="g-breadcrumb" separator="/">
        <el-breadcrumb-item :to="`${$subsitePrefix}/major`">专业信息</el-breadcrumb-item>
        <el-breadcrumb-item>专业导师</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="g-content content">
        <column-header2 :data="metaData"></column-header2>
        <user-list :data="userList"></user-list>
      </div>
    </div>
  </div>
</template>

<script>
import { getData } from "api/app";
import SideNav from "_c/SideNav";
import ColumnHeader from "_c/ColumnHeader2";
import UserList from "../components/UserList";
import { mapState } from 'vuex'

export default {
  data() {
    return {
      metaData: {
        name: "专业导师"
      },
      userList: []
    };
  },
  computed: {
    ...mapState('college', ['collegeData', 'currentMajor'])
  },
  created() {
    this.init();
  },
  components: {
    [SideNav.name]: SideNav,
    [ColumnHeader.name]: ColumnHeader,
    [UserList.name]: UserList
  },
  methods: {
    loadData() {
      const linkDecorator = item => {
        item.link = this.$subsitePrefix + "/major/mentor/detail/" + item.Id;
        return item;
      };
      let params = [
        { Key: 'School', Value: this.collegeData.college.SchoolId, CompareType: 'EqualTo' },
        { Key: 'Major', Value: this.currentMajor.BaseMajorId, CompareType: 'EqualTo' }
      ]
      getData({ name: "SchoolTutor", params: params }).then(res => {
        this.userList = (res || []).map(linkDecorator);
      });
    },
    init() {
      if (!this.currentMajor) {
        this.$router.push(this.$subsitePrefix + '/major')
      }
      this.loadData();
    }
  }
};
</script>

<style lang="scss" scoped>
.page-mentor {
  background: #f6f6f9;
  padding-bottom: 40px;
  ::v-deep .comp-user {
    margin: 10px 48px 0 48px;
  }
  ::v-deep .comp-column-header {
    padding: 10px 0 20px 0;
    margin-left: 48px;
  }
}
</style>
